// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {generateSelectionMap} from '../../../shared/components/facets/dealer-hierarchy/helpers';

const getListOfSelectedDealers = selectedAccounts => Object.keys(selectedAccounts).filter(isSelected => selectedAccounts[isSelected]);

export const updateDealerHierarchyFacet = facets => ({
    facets,
    type: actions.UPDATE_TCSM_AUDIT_DEALER_HIERARCHY_FACET
});

export const resetDealerHierarchyFacet = territories =>

    dispatch => {

        const initializedDealerHierarchy = generateSelectionMap(territories);

        const selectedDealers = getListOfSelectedDealers(initializedDealerHierarchy.selectedAccounts);

        const facets = {
            dealers: selectedDealers,
            ...initializedDealerHierarchy
        };

        dispatch({
            facets,
            type: actions.UPDATE_TCSM_AUDIT_DEALER_HIERARCHY_FACET
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/audits/action-creators/dealer-hierarchy-facet.js